'use client';

import * as React from 'react';
import { Root } from '@radix-ui/react-visually-hidden';

const VisuallyHidden = Root;

export { VisuallyHidden };
